document.addEventListener('DOMContentLoaded', function() {

    ///ABRIR / CERRAR MODAL (compartido)///
    function abrirModal(modal){
        if(!modal) return;
        if(!modal.classList.contains('modal--show')){
            modal.activadorAnterior = document.activeElement;
        }
        modal.removeAttribute('inert');
        modal.setAttribute('aria-hidden', 'false');
        modal.classList.add('modal--show');
        document.body.classList.add('no-scroll');
    }
    function cerrarModal(modal){
        if(!modal) return;
        const activadorAnterior = modal.activadorAnterior;
        modal.classList.remove('modal--show');
        modal.setAttribute('aria-hidden', 'true');
        modal.setAttribute('inert', '');
        if(!document.querySelector('.modal.modal--show')){
            document.body.classList.remove('no-scroll');
        }
        if(activadorAnterior && document.contains(activadorAnterior)){
            activadorAnterior.focus();
        }
    }

    // Los modales cerrados no deben formar parte del orden de tabulación ni
    // ser anunciados por lectores de pantalla.
    document.querySelectorAll('.modal').forEach(modal => {
        if(modal.classList.contains('modal--show')){
            modal.removeAttribute('inert');
            modal.setAttribute('aria-hidden', 'false');
        }else{
            modal.setAttribute('aria-hidden', 'true');
            modal.setAttribute('inert', '');
        }
    });
    // Cerrar con la tecla Escape (el modal visible más reciente)
    document.addEventListener('keydown', function(e){
        if(e.key !== 'Escape') return;
        const modalesAbiertos = document.querySelectorAll('.modal.modal--show');
        if(modalesAbiertos.length){
            cerrarModal(modalesAbiertos[modalesAbiertos.length - 1]);
        }
    });
    // Cerrar al hacer click en el fondo (fuera de la ventana del modal)
    document.querySelectorAll('.modal').forEach(modal => {
        modal.addEventListener('click', function(e){
            if(e.target === modal){
                cerrarModal(modal);
            }
        });
    });

    ///BOTONES ACTIVAR MODAL///
    const botones = document.querySelectorAll('.boton-atajo');
    
    const tablaDashboard = document.getElementById('tabla-dashboard');
    const tablaMercancia = document.getElementById('MercTransito');
    const tablaDetalleImportacion = document.getElementById('DetalleImpo');
    const tablaEstadoReserva = document.getElementById('MisReservas');
    const tablaPanelAutorizacion = document.getElementById('PanelAutorizacion');

    const btnEditarMercancia = document.querySelectorAll ('.btnEditarMercancia');
    
    const estadoClases = {
        'PENDIENTE': 'selectLista-amarillo',
        'APROBADO': 'selectLista-verde',
        'RECHAZADO': 'selectLista-rojo',
        'ELIMINADO': 'selectLista-rojo',
    };

    // Definir las clases de estado
    const estadoClasesNum = {
        1: 'selectLista-amarillo',
        2: 'selectLista-verde',
        3: 'selectLista-rojo',
        4: 'selectLista-rojo'
    };

    //ASIGNA ZONA ERROR
    const inputZonaError = document.querySelectorAll('.imputRojo');
    if(inputZonaError){
        inputZonaError.forEach(input => {
            input.addEventListener('input',function(){
                input.classList.remove('imputRojo');
            });
        });
    }
    //Función para actualizar las clases del estado
    function actualizarClaseEstado(estado, estadoClass) {
        //Limpiar las clases existentes
        Object.values(estadoClasesNum).forEach(clase => {
            estadoClass.classList.remove(clase);
        });
        //Añadir la clase correspondiente según el valor del estado
        if (estadoClasesNum[estado]) {
            estadoClass.classList.add(estadoClasesNum[estado]);
        }
    }
    ///Cerrar ventana modal
    const botonesCerrarModal = document.querySelectorAll('.cerrar_modal');
    botonesCerrarModal.forEach(botonCerrar => {
        botonCerrar.addEventListener('click',function(){
            const idBotonClose = (this.id)
            const modalClose = document.querySelector(idBotonClose)
            cerrarModal(modalClose);
        });
    });
    let controladorDetalle = null;

    async function consultarDetalle(url) {
        if (controladorDetalle) {
            controladorDetalle.abort();
        }

        const controladorActual = new AbortController();
        controladorDetalle = controladorActual;

        try {
            const respuesta = await fetch(url, {
                method: 'GET',
                credentials: 'include',
                cache: 'no-store',
                headers: { 'Accept': 'application/json' },
                signal: controladorActual.signal,
            });
            const cuerpo = await respuesta.json();

            if (!respuesta.ok || !cuerpo.success) {
                const primerError = cuerpo.errors && cuerpo.errors[0];
                const mensaje = (primerError && primerError.message) || 'No fue posible consultar la información.';
                throw new Error(mensaje);
            }

            return cuerpo.result;
        } finally {
            if (controladorDetalle === controladorActual) {
                controladorDetalle = null;
            }
        }
    }

    function mostrarErrorConsulta(error) {
        if (error.name === 'AbortError') return;
        console.error('Error al consultar el detalle:', error);
        alert(error.message || 'No fue posible consultar la información seleccionada.');
    }

    function formatearCantidad(valor) {
        return Number(valor || 0).toLocaleString();
    }

    function llenarModalMercancia(mercancia) {
        const modalReserva = document.querySelector('.ModalReserva');
        if (!modalReserva) return;

        modalReserva.querySelector('#id_mercancia').value = mercancia.id_mercancia;
        modalReserva.querySelector('.no-impo').value = mercancia.nombre_impo;
        modalReserva.querySelector('.detalle').value = mercancia.descripcion;
        modalReserva.querySelector('.codigo').value = mercancia.codigo;
        modalReserva.querySelector('#disponible').value = formatearCantidad(mercancia.disponible);
        modalReserva.querySelector('#numero').value = '';
        modalReserva.querySelector('#cantidad').value = '';
        modalReserva.querySelector('#comentario-reserva').value = '';

        const btnEditar = modalReserva.querySelector('#btnEditarMercancia');
        if (btnEditar) {
            btnEditar.value = mercancia.id_mercancia;
        }

        const modalEditar = document.querySelector('.modalEditarMercancia');
        if (modalEditar) {
            modalEditar.querySelector('#id_mercancia').value = mercancia.id_mercancia;
            modalEditar.querySelector('#nombre_impo').value = mercancia.nombre_impo;
            modalEditar.querySelector('#codigo').value = mercancia.codigo;
            modalEditar.querySelector('#cantidad').value = formatearCantidad(mercancia.cantidad);
            modalEditar.querySelector('#descripcion').value = mercancia.descripcion;
            modalEditar.querySelector('#id_proveedor').value = mercancia.id_proveedor;
            modalEditar.querySelector('#id_grupo').value = mercancia.id_grupo;
            modalEditar.querySelector('#id_permiso_visibilidad').value = mercancia.id_permiso_visibilidad;
        }

        abrirModal(modalReserva);
        modalReserva.querySelector('#numero').focus();
    }

    async function seleccionarMercancia(event) {
        const boton = event.target.closest('.btn-reservar');
        if (!boton || !event.currentTarget.contains(boton)) return;

        event.preventDefault();
        const idMercancia = Number(boton.dataset.id);
        if (!Number.isInteger(idMercancia) || idMercancia < 1) return;

        try {
            const resultado = await consultarDetalle(
                `/api/mercancia/detalle?idMercancia=${encodeURIComponent(idMercancia)}`
            );
            llenarModalMercancia(resultado.mercancia);
        } catch (error) {
            mostrarErrorConsulta(error);
        }
    }

    function formatearFechaReserva(fecha) {
        if (!fecha) return '—';
        const valorFecha = new Date(String(fecha).replace(' ', 'T'));
        if (Number.isNaN(valorFecha.getTime())) return fecha;
        return new Intl.DateTimeFormat('es-CO', {
            dateStyle: 'medium',
            timeStyle: 'short',
        }).format(valorFecha);
    }

    function agregarCelda(fila, valor, clase = '') {
        const celda = document.createElement('td');
        celda.textContent = valor === null || valor === undefined || valor === '' ? '—' : valor;
        if (clase) celda.className = clase;
        fila.appendChild(celda);
    }

    function crearFilaReserva(reserva, mostrarUsuario, esAprobada) {
        const fila = document.createElement('tr');
        agregarCelda(fila, `# ${reserva.id_reserva}`);
        if (mostrarUsuario) agregarCelda(fila, reserva.nombre_usuario);
        agregarCelda(fila, reserva.pedido_sap);
        agregarCelda(fila, formatearCantidad(reserva.solicitud_reserva), 'td-num');
        if (esAprobada) {
            agregarCelda(fila, formatearCantidad(reserva.reserva_autorizada), 'td-num');
        }
        agregarCelda(fila, formatearFechaReserva(reserva.fecha_creacion));
        return fila;
    }

    function prepararModalReservas(modal) {
        const contenido = modal.querySelector('.reservas-mercancia-modal__contenido');
        const estado = modal.querySelector('[data-reservas-estado]');
        contenido.setAttribute('aria-busy', 'true');
        modal.querySelector('.reservas-mercancia-modal__producto').hidden = true;
        modal.querySelector('[data-reservas-alcance]').hidden = true;
        modal.querySelector('.reservas-mercancia-modal__resumen').hidden = true;
        modal.querySelector('[data-reservas-grupos]').hidden = true;
        estado.className = 'reservas-mercancia-modal__estado reservas-mercancia-modal__estado--cargando';
        estado.textContent = 'Cargando reservas…';
        abrirModal(modal);
    }

    function mostrarErrorReservas(modal, error, reintentar) {
        const contenido = modal.querySelector('.reservas-mercancia-modal__contenido');
        const estado = modal.querySelector('[data-reservas-estado]');
        contenido.setAttribute('aria-busy', 'false');
        estado.className = 'reservas-mercancia-modal__estado reservas-mercancia-modal__estado--error';
        estado.textContent = '';

        const mensaje = document.createElement('p');
        mensaje.textContent = error.message || 'No fue posible consultar las reservas.';
        const boton = document.createElement('button');
        boton.type = 'button';
        boton.className = 'btnModal-azulSpray';
        boton.textContent = 'Reintentar';
        boton.addEventListener('click', reintentar, { once: true });
        estado.append(mensaje, boton);
        boton.focus();
    }

    function llenarModalReservas(modal, resultado) {
        const mercancia = resultado.mercancia;
        const reservas = Array.isArray(resultado.reservas) ? resultado.reservas : [];
        const aprobadas = reservas.filter(reserva => Number(reserva.id_estado) === 2);
        const pendientes = reservas.filter(reserva => Number(reserva.id_estado) === 1);
        const mostrarUsuario = resultado.alcance_reservas === 'todas';
        const cuerpoAprobadas = modal.querySelector('[data-reservas-aprobadas]');
        const cuerpoPendientes = modal.querySelector('[data-reservas-pendientes]');

        modal.querySelector('[data-reservas-codigo]').textContent = mercancia.codigo || '—';
        modal.querySelector('[data-reservas-descripcion]').textContent = mercancia.descripcion || '—';
        modal.querySelector('[data-reservas-impo]').textContent = mercancia.nombre_impo || '—';
        modal.querySelector('[data-reservas-alcance]').textContent = mostrarUsuario
            ? 'Se muestran todas las solicitudes aprobadas y pendientes de este código.'
            : 'Se muestran únicamente tus solicitudes aprobadas y pendientes de este código.';

        modal.querySelectorAll('.columna-usuario').forEach(columna => {
            columna.hidden = !mostrarUsuario;
        });

        cuerpoAprobadas.replaceChildren(
            ...aprobadas.map(reserva => crearFilaReserva(reserva, mostrarUsuario, true))
        );
        cuerpoPendientes.replaceChildren(
            ...pendientes.map(reserva => crearFilaReserva(reserva, mostrarUsuario, false))
        );

        const totalAprobado = aprobadas.reduce(
            (total, reserva) => total + Number(reserva.reserva_autorizada || 0),
            0
        );
        const totalPendiente = pendientes.reduce(
            (total, reserva) => total + Number(reserva.solicitud_reserva || 0),
            0
        );

        modal.querySelector('[data-total-aprobado]').textContent = formatearCantidad(totalAprobado);
        modal.querySelector('[data-total-pendiente]').textContent = formatearCantidad(totalPendiente);
        modal.querySelector('[data-total-disponible]').textContent = formatearCantidad(mercancia.disponible);
        modal.querySelector('[data-contador-aprobadas]').textContent = aprobadas.length;
        modal.querySelector('[data-contador-pendientes]').textContent = pendientes.length;

        const vacioAprobadas = modal.querySelector('[data-vacio-aprobadas]');
        const vacioPendientes = modal.querySelector('[data-vacio-pendientes]');
        vacioAprobadas.hidden = aprobadas.length > 0;
        vacioPendientes.hidden = pendientes.length > 0;
        vacioAprobadas.previousElementSibling.hidden = aprobadas.length === 0;
        vacioPendientes.previousElementSibling.hidden = pendientes.length === 0;

        modal.querySelector('[data-reservas-estado]').textContent = '';
        modal.querySelector('[data-reservas-estado]').className = 'reservas-mercancia-modal__estado';
        modal.querySelector('.reservas-mercancia-modal__producto').hidden = false;
        modal.querySelector('[data-reservas-alcance]').hidden = false;
        modal.querySelector('.reservas-mercancia-modal__resumen').hidden = false;
        modal.querySelector('[data-reservas-grupos]').hidden = false;
        modal.querySelector('.reservas-mercancia-modal__contenido').setAttribute('aria-busy', 'false');
        modal.querySelector('.cerrar_modal').focus();
    }

    async function cargarReservasMercancia(idMercancia, modal) {
        prepararModalReservas(modal);
        try {
            const resultado = await consultarDetalle(
                `/api/mercancia/detalle?idMercancia=${encodeURIComponent(idMercancia)}`
            );
            llenarModalReservas(modal, resultado);
        } catch (error) {
            if (error.name === 'AbortError') return;
            mostrarErrorReservas(modal, error, () => cargarReservasMercancia(idMercancia, modal));
        }
    }

    async function seleccionarReservasMercancia(event) {
        const boton = event.target.closest('.btn-ver-reservas');
        if (!boton || !event.currentTarget.contains(boton)) return;

        event.preventDefault();
        const idMercancia = Number(boton.dataset.id);
        const modal = document.querySelector('.ModalReservasMercancia');
        if (!modal || !Number.isInteger(idMercancia) || idMercancia < 1) return;

        await cargarReservasMercancia(idMercancia, modal);
    }

    [tablaDashboard, tablaMercancia, tablaDetalleImportacion]
        .filter(Boolean)
        .forEach(tabla => tabla.addEventListener('click', seleccionarMercancia));

    if (tablaMercancia) {
        tablaMercancia.addEventListener('click', seleccionarReservasMercancia);
    }

    if (tablaEstadoReserva) {
        tablaEstadoReserva.addEventListener('click', async function(event) {
            const boton = event.target.closest('.btn-editarReserva');
            if (!boton || !tablaEstadoReserva.contains(boton)) return;

            event.preventDefault();
            const idReserva = Number(boton.dataset.id);
            if (!Number.isInteger(idReserva) || idReserva < 1) return;

            try {
                const resultado = await consultarDetalle(
                    `/api/reservas/detalle?idReserva=${encodeURIComponent(idReserva)}`
                );
                const reserva = resultado.reserva;
                const modal = document.querySelector('.EstadoReserva');
                const campoSolicitud = modal.querySelector('#cantidad');
                const campoPedido = modal.querySelector('#numero');
                const campoEstado = modal.querySelector('#estado');
                const campoComentario = modal.querySelector('#comentario');

                modal.querySelector('#id_reserva').value = reserva.id_reserva;
                modal.querySelector('#id_mercancia').value = reserva.id_mercancia;
                modal.querySelector('.no-impo').value = reserva.nombre_impo;
                modal.querySelector('.detalle').value = reserva.descripcion;
                modal.querySelector('.codigo').value = reserva.codigo;
                modal.querySelector('#disponible').value = formatearCantidad(reserva.disponible_actual);
                campoPedido.value = reserva.pedido_sap;
                campoSolicitud.value = formatearCantidad(reserva.solicitud_reserva);
                modal.querySelector('#autorizado').value = formatearCantidad(reserva.reserva_autorizada);
                campoEstado.value = reserva.estado;
                campoComentario.value = reserva.comentario || '';

                campoSolicitud.classList.add('readonly');
                campoPedido.classList.add('readonly');
                campoSolicitud.readOnly = true;
                campoPedido.readOnly = true;
                campoComentario.disabled = false;
                campoComentario.classList.remove('readonly');

                const areaBoton = modal.querySelector('.areaBotonModal');
                areaBoton.innerHTML = '';

                const contenedorBotones = document.createElement('div');
                contenedorBotones.className = 'acciones-reserva';

                if (reserva.estado === 'PENDIENTE') {
                    contenedorBotones.innerHTML = `
                        <button id="btnEliminar" type="button" class="btnModal-rojo">Eliminar</button>
                        <button id="btnEditar" type="button" class="btnModal-azulSpray">Editar reserva</button>
                    `;

                    const btnEliminar = contenedorBotones.querySelector('#btnEliminar');
                    const btnEditar = contenedorBotones.querySelector('#btnEditar');

                    btnEditar.addEventListener('click', function() {
                        btnEditar.classList.add('hidden-btn');
                        campoSolicitud.classList.remove('readonly');
                        campoPedido.classList.remove('readonly');
                        campoSolicitud.readOnly = false;
                        campoPedido.readOnly = false;
                        campoSolicitud.focus();
                    });
                    btnEliminar.addEventListener('click', function() {
                        abrirModal(document.getElementById('ModalEliminarReserva'));
                        document.querySelector('#ModalEliminarReserva #id_reserva').value = reserva.id_reserva;
                    });
                }

                contenedorBotones.insertAdjacentHTML('beforeend', `
                    <button type="submit" class="btn-loader btnModal-azulSpray">Guardar cambios</button>
                `);
                areaBoton.appendChild(contenedorBotones);

                Object.values(estadoClases).forEach(clase => campoEstado.classList.remove(clase));
                if (estadoClases[reserva.estado]) {
                    campoEstado.classList.add(estadoClases[reserva.estado]);
                }

                abrirModal(modal);
            } catch (error) {
                mostrarErrorConsulta(error);
            }
        });
    }

    if (tablaPanelAutorizacion) {
        const modal = document.querySelector('.ModalEditarReserva');
        const contenidoReserva = modal.querySelector('#solicitud-reserva');
        const btnEditar = modal.querySelector('#btnEditar');
        const btnAutorizar = modal.querySelector('.areaBotonModal [type="submit"]');
        const campoEstado = modal.querySelector('#id_estado');
        const campoCantidad = modal.querySelector('#cantidad');

        actualizarClaseEstado(campoEstado.value, campoEstado);

        tablaPanelAutorizacion.addEventListener('click', async function(event) {
            const boton = event.target.closest('.btn-editarReserva');
            if (!boton || !tablaPanelAutorizacion.contains(boton)) return;

            event.preventDefault();
            const idReserva = Number(boton.dataset.id);
            if (!Number.isInteger(idReserva) || idReserva < 1) return;

            try {
                const resultado = await consultarDetalle(
                    `/api/reservas/detalle?idReserva=${encodeURIComponent(idReserva)}`
                );
                const reserva = resultado.reserva;

                modal.querySelector('#id_reserva').value = reserva.id_reserva;
                modal.querySelector('#id_mercancia').value = reserva.id_mercancia;
                modal.querySelector('.no-impo').value = reserva.nombre_impo;
                modal.querySelector('.detalle').value = reserva.descripcion;
                modal.querySelector('.codigo').value = reserva.codigo;
                modal.querySelector('#usuario').value = reserva.nombre_usuario;
                modal.querySelector('#pedido_sap').value = reserva.pedido_sap;
                modal.querySelector('#disponible').value = formatearCantidad(reserva.disponible_actual);
                modal.querySelector('#solicitud_reserva').value = formatearCantidad(reserva.solicitud_reserva);
                campoCantidad.value = formatearCantidad(reserva.reserva_autorizada);
                campoEstado.value = reserva.id_estado;
                modal.querySelector('#comentario').value = reserva.comentario || '';

                actualizarClaseEstado(campoEstado.value, campoEstado);
                abrirModal(modal);

                if (reserva.id_estado !== 1) {
                    contenidoReserva.classList.add('readonly');
                    btnAutorizar.classList.add('hidden-btn');
                    btnEditar.classList.remove('hidden-btn');
                    btnAutorizar.textContent = 'Guardar cambios';
                } else {
                    contenidoReserva.classList.remove('readonly');
                    btnAutorizar.classList.remove('hidden-btn');
                    btnEditar.classList.add('hidden-btn');
                    btnAutorizar.textContent = 'Autorizar';
                    campoCantidad.focus();
                }
            } catch (error) {
                mostrarErrorConsulta(error);
            }
        });

        campoCantidad.addEventListener('change', function() {
            campoEstado.value = 2;
            actualizarClaseEstado(campoEstado.value, campoEstado);
        });
        btnEditar.addEventListener('click', function() {
            contenidoReserva.classList.remove('readonly');
            btnAutorizar.classList.remove('hidden-btn');
            btnEditar.classList.add('hidden-btn');
            campoCantidad.focus();
        });
    }

    ///Iniciar ventana modal
    botones.forEach(boton => {
        boton.addEventListener('click',function(){
            // Muestra el ID del botón en la consola
            const idBoton = (this.id)
            const modal = document.querySelector(idBoton)
            abrirModal(modal);
        });
    });
    //Editar mercancia
    btnEditarMercancia.forEach(btnEditarMerc => {
        btnEditarMerc.addEventListener('click',function(){
            // Obtener el valor del atributo data-id del boton
            cerrarModal(document.querySelector('.ModalReserva'));
            abrirModal(document.querySelector('.modalEditarMercancia'));
        });
    });

});
